import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";

export interface INavigationCommand {
    id: string;
    title: string;
    tooltip: string;
    classes: string;
    active: boolean;
    onClick: () => void;
}

export interface IFooterProp {
    isReadOnly?: boolean;
    buttonTitle?: string;
    buttonClass?: string;
    onClick?: () => void;
    commands?: INavigationCommand[];
}

export class Footer extends React.Component<IFooterProp> {
    render() {
        const props = this.props;
        const commands = props.commands ?? [];
        const buttonTitle = props.buttonTitle ?? Translations.Save;
        const buttonClass = props.buttonClass ?? "save mui";
        return (
            <div className="toolbar">
                {!props.isReadOnly && (!!props.onClick || commands.length) &&
                    <div className="buttons">
                        {commands.map((command) => (
                            <ToolButton
                                key={command.id}
                                stopPropagation={true}
                                title={command.title}
                                classes={(command.classes ? " " + command.classes : "") + (command.active ? " active" : "")}
                                tooltip={command.tooltip}
                                onClick={command.onClick}
                            />
                        ))}
                        {!!props.onClick &&
                            <ToolButton
                                classes={buttonClass}
                                title={buttonTitle}
                                tooltip={buttonTitle}
                                onClick={props.onClick}
                            />
                        }
                    </div>
                }
            </div>
        );
    }
}